import { useEffect, useState } from "react";

import Header from "./components/Header";
import Carousel from "./components/Carousel";
import Call from "./components/Call";
import PorqueElegirnos from "./components/PorqueElegirnos";
import Services from "./components/Services";
import Footer from "./components/Footer";
import Formulario from "./components/Formulario";
import Promo from "./components/Promo";
import CasosExito from "./components/CasosExito";
import Section1 from "./components/Section1";
import CustomModal from "./components/CustomModal"; 
import Gallery from "./components/Gallery";
import "./styles/App.scss";

function App() {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const hasSeenModal = sessionStorage.getItem("promoSeen");
    if (!hasSeenModal) {
      setShowModal(true);
      sessionStorage.setItem("promoSeen", "true");
    }
  }, []);

  const handleClose = () => setShowModal(false);

  return (
    <div>
      <CustomModal show={showModal} onClose={handleClose} />
      <Header />
      <Section1 />
      <Promo />
      <Carousel />
      <PorqueElegirnos />
      <Promo />
      <Call />
      <Services />
      <Gallery />
      <CasosExito />
      <Formulario />
      <Footer />
    </div>
  );
}

export default App;
